import { render, staticRenderFns } from "./AxisY2.vue?vue&type=template&id=222a69fa&"
import script from "./AxisY2.vue?vue&type=script&lang=ts&"
export * from "./AxisY2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports